import React from "react";
import Button from "@mui/material/Button";

import { FRONTEND_LMS_URL } from "../../../../common/utils/constants";
import useJoinCourse from "../../custom-hooks/useJoinCourse";
import SpinnerButton from "@packages/common/src/components/form/SpinnerButton";
import withSnackbarRefProvider from "../../../../common/components/notification/withSnackbarRefProvider";

const EnrollActions: React.FC<NSCourses.IEnrollActionsProps> = ({
  userEnrolled,
  slug,
  enrollUrl,
}) => {
  const { disableButton, handleJoinCourse } = useJoinCourse(enrollUrl);

  return userEnrolled ? (
    <Button
      href={`${FRONTEND_LMS_URL}/${slug}`}
      variant="contained"
      color="primary"
    >
      Go to course
    </Button>
  ) : (
    <SpinnerButton
      variant="contained"
      color="primary"
      onClick={handleJoinCourse}
      disabled={disableButton}
    >
      Enroll now
    </SpinnerButton>
  );
};

export default withSnackbarRefProvider(
  EnrollActions
) as React.FC<NSCourses.IEnrollActionsProps>;
